/* global MAPBOX_ACCESS_TOKEN */
import React, { Component } from 'react';
import { isNewHomePageApplicable } from '../constants/feature';
// import mapboxgl from 'mapbox-gl';
const mapboxgl = process.browser ? require('mapbox-gl') : {};

class MapboxMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // lng: this.props.currentLocation.lng,
      // lat: this.props.currentLocation.lat,
      zoom: 14
    };
    mapboxgl.accessToken = process.env.NEXT_PUBLIC_MAPBOX_ACCESS_TOKEN;
  }

  componentDidMount() {
    const {
      currentLocation: { longitude, latitude }
    } = this.props;
    const { zoom } = this.state;
    if (process.browser && mapboxgl.supported()) {
      this.map = new mapboxgl.Map({
        container: this.mapContainer,
        style: `mapbox://styles/mapbox/streets-${isNewHomePageApplicable ? "v10" : "v12"}`,
        center: [longitude, latitude],
        zoom
      });
      // setting initial value on map load for the pin selection if done without movement avoiding undefined
      const calculatedLat1 = this.map.getCenter().lat;
      const calculatedLng1 = this.map.getCenter().lng;
      this.props.setCoordinates({
        lng: calculatedLng1,
        lat: calculatedLat1
      });
      // setting coordinates value for the pin selection when moved
      this.map.on('move', () => {
        const calculatedLat = this.map.getCenter().lat;
        const calculatedLng = this.map.getCenter().lng;
        this.setState({
          zoom: this.map.getZoom().toFixed(2)
        });
        this.props.setCoordinates({
          lng: calculatedLng,
          lat: calculatedLat
        });
      });
    }
  }

  render() {
    return (
      <div id="map" className=" map">
        <div
          ref={el => (this.mapContainer = el)}
          className="map-container"
          style={{
            height: '100vh',
            width: '100%',
            backgroundColor: '#eceeed'
          }}
        />
        {process.browser && !mapboxgl.supported() && <div>Map box not supported</div>}
      </div>
    );
  }
}

export default MapboxMap;
